import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import AppShell from "@/components/common/AppShell";
import DevicesPage from "@/features/devices/pages/DevicesPage";
import DeviceDetailPage from "@/features/devices/pages/DeviceDetailPage";
import { Smartphone, LogOut } from "lucide-react";

export default function ProviderApp() {
  const { currentUser, currentUserType, logout } = useApp();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const sections = [
    {
      heading: "Traffic",
      items: [
        {
          to: "/provider/devices",
          label: "Devices",
          icon: Smartphone,
        },
      ],
    },
  ];

  const routeTitles = {
    "/provider/devices": "Devices",
  };

  const sidebarFooter = (
    <div className="flex items-center gap-2 rounded-(--radius-md) border border-(--border-subtle) bg-(--surface-2) px-3 py-2">
      <span
        aria-hidden="true"
        className="inline-flex h-2 w-2 rounded-(--radius-pill) bg-(--status-success)"
      />
      <div className="min-w-0 text-xs">
        <div className="font-semibold text-(--text-primary)">System status</div>
        <div className="text-(--text-muted)">All systems operational</div>
      </div>
    </div>
  );

  return (
    <AppShell
      brand="Adlywise"
      brandSubtitle="Provider"
      roleLabel="Provider"
      sections={sections}
      sidebarFooter={sidebarFooter}
      routeTitles={routeTitles}
      user={{ name: currentUser, role: currentUserType }}
      userMenuItems={[{ label: "Logout", icon: LogOut, onClick: handleLogout }]}
    >
      <Routes>
        <Route index element={<Navigate to="/provider/devices" replace />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="device/:deviceId" element={<DeviceDetailPage />} />
        <Route path="*" element={<Navigate to="/provider/devices" replace />} />
      </Routes>
    </AppShell>
  );
}
